
import { Hardware } from "@/types";
import { useAdminTable } from "@/hooks/useAdminTable";

const mapSupabaseHardware = (item: any): Hardware => ({
  id: item.id,
  manufacture: item.manufacture || "", 
  product: item.product || "",
  part_number: item.part_number || "",
  product_type: item.product_type || "battery",
  description: item.description || "",
  specification: item.specification || "",
  images: item.images || [],
  currency_conversion_rate: item.currency_conversion_rate || 1.0,
  exchange_rate_buffer_percent: item.exchange_rate_buffer_percent || 0,
  shipping_cost: item.shipping_cost || 0,
  gst_rate: item.gst_rate || 10,
  markup_rate: item.markup_rate || 0,
  markup_per_unit: item.markup_per_unit || 0,
  use_fixed_margin: item.use_fixed_margin || false,
  gst_on_shipping: item.gst_on_shipping || true,
  rounding: item.rounding || 0,
  created_at: item.created_at || null,
  updated_at: item.updated_at || null,
  visible_in_marketplace: item.visible_in_marketplace || false
});

export function useHardwareAdmin() {
  const {
    items: hardware,
    filteredItems: filteredHardware,
    setItems: setHardware,
    searchQuery,
    setSearchQuery,
    fetchItems: fetchHardwareData,
    isLoading,
    error
  } = useAdminTable<Hardware>('hardware', 'manufacture', mapSupabaseHardware);

  // Wrapper function that returns the fresh data
  const fetchHardware = async () => {
    console.log("[useHardwareAdmin] Fetching hardware data...");
    const freshData = await fetchHardwareData();
    console.log("[useHardwareAdmin] Fetched", freshData.length, "hardware items");
    return freshData;
  };

  return {
    hardware,
    filteredHardware,
    setHardware,
    searchQuery,
    setSearchQuery,
    fetchHardware,
    isLoading,
    error
  };
}
